import React from 'react';
import { Provider } from "react-redux";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Content from "./components/Content";
import Home from "./routes/Home";
import Cart from "./routes/Cart";
import Checkout from "./routes/Checkout";
import Confirmation from "./routes/Confirmation";
import EventPage from "./routes/EventPage";
import HowItWorks from "./routes/HowItWorks";
import Login from "./routes/Login";
import FullContentMessage from "./components/FullContentMessage";
import createStore from "./store";
import { BrowserRouter as Router, Switch, Route, matchPath } from "react-router-dom";
import './App.scss';
import EmailPage from './routes/EmailPage';
import { setMaintenanceHandler } from "./utils";

const store = createStore();

const MAINTENANCE_TITLE = "Sorry, Met Opera Premier is under maintenance";

export default class App extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      sessionLoaded: false,
      inMaintenance: false,
      maintenanceMessage: undefined,
    }
  };

  componentDidMount() {
    // Middleware gates every client GET with 503 + { message } while
    // maintenance mode is on for WEB. Header's launch chain (dynamic_strings ->
    // screen -> user_info) is all gated, so without this the session never
    // loads and the user gets an empty page with no explanation.
    setMaintenanceHandler((maintenanceMessage) => {
      this.setState({ inMaintenance: true, maintenanceMessage });
    });

    // Close the mobile menu if the user clicks outside of it
		window.onclick = function(event) {
      if (!event.target.matches(".nav-humburger-button > svg")) {
        let mobileMenu = document.getElementById("mobile-menu");
        if (mobileMenu && mobileMenu.style.display === "block") {
          mobileMenu.style.display = "none";
        }
			}
		};
  }

  onSessionLoaded = () => {
    this.setState({ sessionLoaded: true })
  }

  isEmailRoute = () => {
    return !!matchPath(window.location.pathname, {
      path: "/emails/:emailType/:orderId",
      exact: true
    });
  }

  render() {
    const { sessionLoaded, inMaintenance, maintenanceMessage } = this.state;
    return (
      <div className="App">
        <Router>
          <Provider store={store}>
          { this.isEmailRoute()
            ? <Route path="/emails/:emailType/:orderId" exact component={EmailPage} />
            : <>
                <Header onLoad={this.onSessionLoaded} />
                {/* Checked before the sessionLoaded gate: during maintenance the
                    session can never load, so gating the message behind it would
                    leave the user on a blank page. */}
                { inMaintenance &&
                  <Content>
                    <FullContentMessage
                      className="maintenance"
                      title={MAINTENANCE_TITLE}
                      body={maintenanceMessage}
                    />
                  </Content>
                }
                { !inMaintenance && sessionLoaded &&
                  <Content>
                    <Switch>
                      <Route path="/" exact render={() => <Home />} />
                      <Route path="/cart" exact component={Cart} />
                      <Route path="/checkout" exact component={Checkout} />
                      <Route path="/confirmation/:orderId" exact component={Confirmation} />
                      <Route path="/events/:eventId" exact component={EventPage} />
                      <Route path="/how-it-works" exact render={() => <HowItWorks />} />
                      <Route path="/login" exact render={() => <Login  onLoad={this.onSessionLoaded} /> }  />
                    </Switch>
                  </Content>
                }
                <Footer />
              </>
          }
          </Provider>
        </Router>
      </div>
    );
  }
};
